/** Maximale Zeichenanzahl für den Fließtext eines Announcements (siehe shell-service-openapi.yml → maxLength: 255). */
export const CONTENT_MAX_LENGTH = 255;
